// src/Pages/ConnectWallet/appkit-init.js
import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { bsc, bscTestnet } from "@reown/appkit/networks";

// Replace with your actual project ID
const projectId = process.env.REACT_APP_PROJECT_ID || "954f19ecde347bba3ace9c453bb92626";

// Get network from environment variable
const networkType = process.env.REACT_APP_NETWORK || 'testnet';

// Select networks based on environment
let networks;
let defaultNetwork;

if (networkType === 'mainnet') {
  networks = [bsc];
  defaultNetwork = bsc;
  console.log('🚀 AppKit initialized with MAINNET (BSC)');
} else {
  networks = [bscTestnet];
  defaultNetwork = bscTestnet;
  console.log('🧪 AppKit initialized with TESTNET (BSC Testnet)');
}

// Optional: Add your website metadata
const metadata = {
  name: "The Meme TV",
  description: "Turning your screen time into earnings with memes and tokens.",
  url: "https://app.thememetv.com", // must match your deployed URL
  icons: ["https://avatars.mywebsite.com/"],
};

// Initialize AppKit
createAppKit({
  adapters: [new EthersAdapter()],
  networks,
  defaultNetwork,
  metadata,
  projectId,
  features: {
    analytics: true, //Optional
    email: false, //Optional\
    google: false, //Optional
    socials: false, //Optional,
  },
});
